import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchMidpointMediaCrmLeads } from "../../../api/midpointMediaAdminApi";
import {
  ClientPortalError,
  ClientPortalLoading,
} from "../../../components/clientPortal/ClientPortalStates";
import useMidpointMediaAdminView from "../../../hooks/useMidpointMediaAdminView";
import { formatClientDateTime } from "../../../utils/clientPortalFormat";
import "../../../styles/midpointMediaAdmin.css";

export default function MidpointMediaAdminCrmLeadsPage() {
  const { clientViewId, paths } = useMidpointMediaAdminView();
  const [q, setQ] = useState("");
  const [state, setState] = useState({ loading: true, error: "", rows: [] });

  useEffect(() => {
    if (!clientViewId) return undefined;
    let cancelled = false;
    setState((current) => ({ ...current, loading: true, error: "" }));
    fetchMidpointMediaCrmLeads(clientViewId, { q })
      .then((body) => {
        if (!cancelled) setState({ loading: false, error: "", rows: body.rows || [] });
      })
      .catch((error) => {
        if (!cancelled) setState({ loading: false, error: error.message, rows: [] });
      });
    return () => {
      cancelled = true;
    };
  }, [clientViewId, q]);

  if (!clientViewId) return <p className="empty-state">No workspace assigned.</p>;

  return (
    <div className="mm-admin-page">
      <header>
        <p className="mm-admin-kicker">CRM · Leads</p>
        <h1>Leads</h1>
        <p className="mm-admin-lead">
          Every Midpoint Media inquiry and job application lands here. Open a row for contact
          details, résumé notes, and the linked opportunity.
        </p>
      </header>
      <label className="mm-admin-card">
        Search
        <input
          type="search"
          value={q}
          onChange={(event) => setQ(event.target.value)}
          placeholder="Name, email, reference…"
        />
      </label>
      {state.loading ? <ClientPortalLoading message="Loading leads…" /> : null}
      {state.error ? <ClientPortalError message={state.error} /> : null}
      {!state.loading && !state.rows.length ? <p className="empty-state">No matching leads.</p> : null}
      {state.rows.length ? (
        <table className="mm-admin-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Role / type</th>
              <th>Status</th>
              <th>Received</th>
            </tr>
          </thead>
          <tbody>
            {state.rows.map((lead) => (
              <tr key={lead.id}>
                <td>
                  <Link to={`${paths.base}/crm/leads/${lead.id}`}>{lead.name}</Link>
                  <div className="muted">{lead.email || lead.phone || "—"}</div>
                </td>
                <td>{lead.roleType || lead.leadType || "—"}</td>
                <td>{lead.status}</td>
                <td>{formatClientDateTime(lead.createdAt)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : null}
    </div>
  );
}
